import { Component, Input, Output, EventEmitter, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { InteractivityDesignDimensionsService, DesignDimensions } from '../../services/interactivity-design-dimensions.service';
import { OverlayService } from '../../../../../services/overlay.service';
import { InteractivityEditorService } from '../../services/interactivity-editor.service';

@Component({
	selector: 'ie-design-dimensions',
	templateUrl: './ie-design-dimensions.component.html',
	styleUrls: ['./ie-design-dimensions.component.scss']
})

export class IeDesignDimensionsComponent implements OnInit, OnDestroy {

	@Input() items: { label: string; value: any }[];
	@Input() modal: any;
	@Input() isApp: boolean;
	@Output() onOpened: EventEmitter<any> = new EventEmitter<any>();
	@Output() closed: EventEmitter<any> = new EventEmitter<any>();
	@Output() ok: EventEmitter<any> = new EventEmitter<any>();
	@Output() cancel: EventEmitter<any> = new EventEmitter<any>();
	@Output() reset: EventEmitter<any> = new EventEmitter<any>();

	designDimensions: DesignDimensions;
	currentMediaclipAsset: any = null;
	aspectRatio: number;
	aspectRatioLocked = true;
	private subscriptions = new Subscription();

	constructor(
		private overlayService: OverlayService,
		private editorService: InteractivityEditorService,
		private designDimensionsService: InteractivityDesignDimensionsService) {
	}

	ngOnInit() {
		this.subscriptions.add(this.designDimensionsService.designDimensionsSubject.subscribe((designDimensions) => {
			this.designDimensions = { ...designDimensions };
			this.aspectRatio = this.designDimensions.width / this.designDimensions.height;
		}));

		this.subscriptions.add(this.editorService.mediaclipAssetSubject.subscribe((mediaclipAsset) => {
			this.currentMediaclipAsset = mediaclipAsset;
		}));
	}

	ngOnDestroy() {
		this.closed.emit();
		this.subscriptions.unsubscribe();
	}

	onDimensionChanged(prop: 'w' | 'h') {
		if (this.aspectRatioLocked) {
			if (prop === 'w') {
				this.designDimensions.height = this.designDimensions.width / this.aspectRatio;
			} else {
				this.designDimensions.width = this.designDimensions.height * this.aspectRatio;
			}
		} else {
			this.aspectRatio = this.designDimensions.width / this.designDimensions.height;
		}
	}

	onResetClick() {
		if (!this.isApp) {
			this.designDimensions.width = this.editorService.parentEntity.width || this.currentMediaclipAsset.width;
			this.designDimensions.height = this.editorService.parentEntity.height || this.currentMediaclipAsset.height;
		} else if (this.editorService.parentEntity && this.editorService.parentEntity.width && this.editorService.parentEntity.height) {
			this.designDimensions.width = this.editorService.parentEntity.width;
			this.designDimensions.height = this.editorService.parentEntity.height;
		}
		this.aspectRatio = this.designDimensions.width / this.designDimensions.height;
		this.reset.emit(this.designDimensions);
	}

	closeModal() {
		if (this.modal) {
			this.overlayService.removeModal(this.modal);
		}
	}

	onOkClick() {
		this.designDimensionsService.setDesignDimensions(this.designDimensions);
		this.ok.emit(this.designDimensions);
		this.closeModal();
	}
}
